import PageContainer from 'components/PageContainer';
import PageHeading from 'components/PageHeading';
import Spinner from 'components/Spinner';
import useAuthStore from 'store/authStore';

function LoadingPage() {
  const { token } = useAuthStore();
  let status = 'Loading page';
  if (!token) {
    status = 'Authenticating';
  }
  return (
    <PageContainer>
      <PageHeading>Loading</PageHeading>

      <div className="shadow-card inline-flex flex-col items-center justify-center rounded-md bg-white p-5">
        <div className="pb-3">
          <Spinner />
        </div>
        <div className="text-lg">{status}</div>
      </div>
    </PageContainer>
  );
}

export default LoadingPage;
